import { ROUTER_LIST } from './constants/router'
import modules from './store/storeModulesList'

window.vue.$router.addRoutes([...ROUTER_LIST])
for (let i in modules) {
  window.vue.$store.registerModule(i, modules[i])
}



// WEBPACK FOOTER //
// ./src/main-prod.js